const guiColors = {
    'motion-primary': 'hsla(30, 100%, 55%, 1)',
    'motion-primary-transparent': 'hsla(30, 100%, 55%, 0.9)',
    'motion-tertiary': 'hsla(30, 100%, 43%, 1)',

    'looks-secondary': 'hsla(30, 100%, 55%, 1)',
    'looks-transparent': 'hsla(30, 100%, 55%, 0.35)',
    'looks-light-transparent': 'hsla(30, 100%, 55%, 0.15)',
    'looks-secondary-dark': 'hsla(30, 100%, 43%, 1)',

    'extensions-primary': 'hsla(40, 85%, 55%, 1)',
    'extensions-tertiary': 'hsla(40, 85%, 30%, 1)',
    'extensions-transparent': 'hsla(40, 85%, 55%, 0.35)',
    'extensions-light': 'hsla(40, 57%, 75%, 1)',

    'drop-highlight': 'hsl(30, 100%, 68%)'
};

const blockColors = {
    checkboxActiveBackground: 'hsl(30, 100%, 55%)',
    checkboxActiveBorder: 'hsl(30, 100%, 43%)'
};

export {
    guiColors,
    blockColors
};